
<div class="container p-4"> 
    <div class="row">
<h4 class="head">Assign More Distributors into your network</h4>
    </div>
    <form [formGroup]="assignMoreDistributorsForm">
    <div class="row">
     
        <div class="col-lg-3" style="margin-top: 20px;" >
          
            <div>
                <mat-form-field appearance="outline" class="fields input-font w-100">
                    <mat-icon matPrefix>search</mat-icon>
                    <input type="text" aria-label="Number" placeholder="Search"  [formControl]="search" matInput (input)="searchOEM($event)"> 
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-3" >
            <div >
                <mat-label class="label">Country</mat-label>
            </div>           
                <div>
                    <mat-form-field appearance="outline" class="fields input-font w-100">

                        <input type="text" placeholder="Select" aria-label="Number" matInput [formControl]="country" [matAutocomplete]="auto" (input)="getCountryDropdown($event)">
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCountrySelected($event)">
                          <mat-option *ngFor="let option of countryDropdown" [value]="option?.countryName" >
                            {{ option?.countryName }}
                          </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
        </div>
        <div class="col-lg-3" >
            <div >
                <mat-label class="label">State</mat-label>
            </div>
            <div>
                <mat-form-field appearance="outline" class="fields input-font w-100">
                    <input type="text" placeholder="Select" aria-label="Number" matInput [formControl]="state" [matAutocomplete]="stateAuto" (input)="getStatesDropdown($event)">
                    <mat-autocomplete #stateAuto="matAutocomplete" (optionSelected)="onStateSelected($event)" >
                      <mat-option *ngFor="let option of stateDropdown" [value]="option?.stateName">
                        {{ option?.stateName }}
                      </mat-option>
                    </mat-autocomplete>
                    
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-3 mb-4" >
            <div >
                <mat-label class="label">City</mat-label>
            </div>
            <div>
                <mat-form-field appearance="outline" class="fields input-font w-100">
                    <input type="text" placeholder="Select" aria-label="Number" matInput [formControl]="city" [matAutocomplete]="cityAuto" (input)="getCityDropdown($event)">
                    <mat-autocomplete #cityAuto="matAutocomplete"  (optionSelected)="onCitySelected($event.option.value)">
                      <mat-option *ngFor="let option of cityDropdown" [value]="option?.cityName">
                        {{ option?.cityName }}
                      </mat-option>
                    </mat-autocomplete>
                    
                </mat-form-field>
            </div>
        </div>


       
    </div>
    </form>
    <div class="table-content">

        <app-mwe-table [columns]="columns" [showSearch]="true" [preSelectedList]="selectedIds" [showHeader]="false" [data]="distributorsNetwork" 
        (selectedAction)="selectedAction($event)" [isDynemicPagination]="true" (pageChanged)="onPageChanged($event)" [totalEntries]="totalEntries"
        [currentPageChanged]="pageIndex" ></app-mwe-table>
    </div>
    <div class="popup-action mt-4">
        <button  class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3" (click)="addDistributors()">Add</button>
        
        <button  class="mwe-button mwe-button--secondary ps-3 pe-3 "  (click)="closeDialog()">Cancel</button>
    </div>
</div>
